import {
  PrivyClientConfig,
  PrivyProvider as Provider,
} from "@privy-io/react-auth";

import logo from "../assets/images/logo.svg";

const privyConfig: PrivyClientConfig = {
  embeddedWallets: {
    ethereum: {
      createOnLogin: "all-users",
    },
    solana: {
      createOnLogin: "all-users",
    },
    requireUserPasswordOnCreate: false,
  },
  loginMethods: ["twitter"],
  appearance: {
    theme: "#171717",
    showWalletLoginFirst: false,
    logo: logo,
    accentColor: "#ffffff",
  },
};

const appId = process.env.REACT_APP_PRIVY_APP_ID as string;
// const clientId = process.env.REACT_APP_PRIVY_CLIENT_ID as string;

export const PrivyProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <Provider
      appId={appId}
      // uncomment this line if you want to use extension flow
      // clientId={clientId}
      config={privyConfig}
    >
      {children}
    </Provider>
  );
};
